import { render } from "./CoopSection.vue?vue&type=template&id=5aba6a6f&scoped=true"
const script = {}

import "./CoopSection.vue?vue&type=style&index=0&id=5aba6a6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aba6a6f"]])

export default __exports__